import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import AuthIdentityVerification from 'auth/magic_link/AuthIdentityVerification';
import React from 'react';
import reducer from 'reducers/reducer';

const store = configureStore({
  reducer,
  preloadedState: {
    errors: {},
    isDisabled: {},
    socialSecurityNumber: '',
    ssnConfirmed: false
  }
});

function AuthMagicLinkLogin({ navigate }) {
  return (
    <Provider store={store}>
      <AuthIdentityVerification navigate={navigate} />
    </Provider>
  );
}

export default AuthMagicLinkLogin;
